import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      // Get the original redirect URL from localStorage (saved before login)
      // Default to home page '/' instead of community for better UX
      const originalRedirect = localStorage.getItem('mart_auth_redirect') || localStorage.getItem('mart_redirect_after_login') || '/';
      // Clean up after reading
      localStorage.removeItem('mart_auth_redirect');
      localStorage.removeItem('mart_redirect_after_login');
      
      if (!sessionIdMatch) {
        console.error("No session_id found in URL");
        navigate(originalRedirect, { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await fetch(`${BACKEND_URL}/api/auth/session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          throw new Error("Failed to create session");
        }

        const data = await response.json();
        
        // Store session token in localStorage for cross-domain support
        if (data.session_token) {
          localStorage.setItem('mart_session_token', data.session_token);
        }
        
        // Navigate back to the original page (not always community)
        navigate(originalRedirect, { 
          replace: true, 
          state: { user: data.user || data } 
        });
      } catch (error) {
        console.error("Auth error:", error);
        navigate(originalRedirect, { replace: true });
      }
    };

    processAuth();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-muted-foreground">מתחבר...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
